<template>
  <div>
    <HistamineModal />
    <div>
      <HistamineItem v-for="(item, index) in currentItems" :key="index + item.name" :searchTerm="searchInput" :itemData="item"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import HistamineItem from '@/components/HistamineItem.vue'
import HistamineModal from '@/components/HistamineModal.vue'

export default {
  components: {
    HistamineItem, HistamineModal
  },
  data() {
      return {
          foodsLoaded: false,
          additivesLoaded: false,
          additivesEnabled: false,
          currentItems: [],
          currentCategories: [],
          currentRatings: [],
          defaultRatings: ['0', '1', '2', '3', '?'],
          foodsList: [],
          additiveList: [],
          apiCategories: ['EGGS','DAIRY','MEAT','FISH','SEAFOOD','MISC','STARCH','NUTS','FATS','VEG','HERBS','FRUITS','SEEDS','FUNGI','SWEETENERS','SPICES','WATER','ALCOHOL','TEA','JUICES','CAFFEINE','OTHERMILKS','SOFTDRINKS','ADDITIVES','VITAMINS','MIXTURES'],
          defaultCategories: ['EGGS','DAIRY','MEAT','FISH','SEAFOOD','MISC','STARCH','NUTS','FATS','VEG','HERBS','FRUITS','SEEDS','FUNGI','SPICES','WATER','ALCOHOL','TEA','JUICES','CAFFEINE','OTHERMILKS','SOFTDRINKS'],
          apiUrl: 'https://648684yww6.execute-api.eu-west-2.amazonaws.com/v1',
          cdnUrl: 'https://histamine-api-cdn.s3.eu-west-2.amazonaws.com',
          searchInput: ''
      }
  },
  computed: {

  },
  watch: {
      currentCategories() {
        this.currentItems = []
          for (let i = 0; i < this.foodsList.length; i++){
              if (this.currentCategories.includes(this.foodsList[i].type)){
                  this.currentItems.push.apply(this.currentItems, this.foodsList[i].data)
              }
          }
      },
      currentRatings() {
        let tempItems = []
        for (let j = 0; j < this.currentItems.length; j++){
          if (this.currentRatings.includes('' + this.currentItems[j].sco)){
            tempItems.push(this.currentItems[j])
          }
        }
        this.currentItems = tempItems
      }
  },
  methods: {
      afterDataLoad() {
        this.$root.$on('doSearch', val => { this.searchInput = val })
      },
      getFoods() {
        return axios.get(this.cdnUrl + "/foods.json").then(response => {
            this.foodsList = response.data
            this.foodsLoaded = true
        })
      },
      getAdditives() {
        return axios.get(this.cdnUrl + "/additives.json").then(response => {
            this.additiveList = response.data
            this.additivesLoaded = true
        }) 
      },
      getFood(food) {
        axios.get(this.apiUrl + "/foods/" + food).then(response => {response.data})
      },
      getAdditive(additive) {
        axios.get(this.apiUrl + "/additives/" + additive).then(response => {response.data})
      },
      resetFilters() {
        this.currentRatings = [...this.defaultRatings]
        this.currentCategories = [...this.defaultCategories]
      }
  },
  mounted() {
      this.getFoods().then(() => {
        this.resetFilters()
        if (this.additivesEnabled) {
          this.getAdditives().then(() => { 
            this.currentCategories.push('SWEETENERS', 'ADDITIVES', 'VITAMINS')
            this.afterDataLoad()
          })
        } else {
          this.afterDataLoad()
        }
      })

      this.$root.$on('openFilterMenu', () => {
        
      })

      this.$root.$on('emptyFilter', () => this.resetFilters())

      this.$root.$on('doFilter', val => { 
        this.currentRatings = []
        this.currentCategories = []
        this.currentCategories = val[1] || this.defaultCategories
        this.currentRatings = val[0] || this.defaultRatings
        this.$el.scrollIntoView()
      })
      
  }
}
</script>

<style lang="scss">

</style>
